import { graphql } from 'react-relay';

export default graphql`
    query headerRootQuery(
        $hasUserId: Boolean!
        $previewKey: String = ""
        $showMarketingMessages: Boolean!
        $fetchMarketingMessagesTransactions: Boolean = false
        $userId: String!
        $userIds: [String]!
        $fetchRegionalInfo: Boolean!
    ) {
        viewer {
            ...Header_viewer
        }
        serverViewer: viewer {
            navigation(rootId: $previewKey) {
                ...Header_navigation
            }
            tradeNavigation: navigation(userType: TRADE, rootId: $previewKey) {
                ...Header_tradeNavigation
            }
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    previewKey: '',
    showMarketingMessages: false,
    fetchRegionalInfo: false,
    userId: '',
    userIds: [],
};
